/* eslint-disable no-param-reassign */
'use strict';
var focusHelper = require('brand_core/components/focus');
var slickSlider = require('brand_core/thirdParty/slickSlider');
var breakpoints = require('brand_core/components/breakpoints');
var giftMessage = require('brand_core/components/giftMessage');
var scrollMore = require('brand_core/components/quickViewScrollMore');
var utils = require('brand_core/utils');
var pinchZoom = require('pinch-zoom-js/src/pinch-zoom');
var imagesLoaded = require('imagesloaded/imagesloaded');
var debounce = require('lodash/debounce');
var carouselPrimarySelector = '.pdp-primary-images';
var carouselThumbnailSelector = '.product-image-container .product-thumbnails';
var isResizeInitialized = false;
require('jquery-zoom/jquery.zoom.js');
var resizeTimerInternal;
var thumbnailsHeightTimer;

/**
 * Helper function to check if device is touch enabled
 * @returns {boolean} - Flag to indicate if device is touch screen or not
 */
function isTouchDevice() {
    return (('ontouchstart' in document.documentElement) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

/**
 * Helper function to check if in quick view modal
 * @returns {jquery} -
 */
function isQuickView() {
    return $('.quick-modal.show').length > 0;
}

/**
 * Zoom image for portrait orientation
 */
function zoomImgPortrait() {
     /* eslint-disable no-param-reassign */
    window.pinchZoomObj.forEach((po) => {
        po.zoomFactor = 2;
        po.update();
    });
    setTimeout(() => {
        window.pinchZoomObj.forEach((po) => {
            po.offset.x = window.innerWidth / 2;
            po.offset.y = window.innerHeight / 2;
            po.update();
        });
    }, 0);
}

/**
 * Zoom image for landscape orientation
 */
function zoomImgLandscape() {
    window.pinchZoomObj.forEach((po) => {
        po.zoomFactor = 1;
        po.update();
    });
    setTimeout(() => {
        window.pinchZoomObj.forEach((po) => {
            po.offset.x = 0;
            po.offset.y = 0;
            po.update();
        });
    }, 0);
}

/**
 * Initialize mobile-only slider for zoom modal
 * @param {jquery} $slidername -
 * @param {jquery} $dots -
 * @param {jquery} $arrows -
 * @param {jquery} $breakpoint -
 * @param {jquery} $initialSlide -
 */
function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint, $initialSlide) {
    var slider = $($slidername);

    // Issues C+D: explicit aria-labeled arrows so NVDA reads them correctly
    var prevArrowHtml = '<button class="slick-prev slick-arrow" type="button" aria-label="Previous image"></button>';
    var nextArrowHtml = '<button class="slick-next slick-arrow" type="button" aria-label="Next image"></button>';

    var settings = {
        mobileFirst: true,
        slidesToShow: 1,
        initialSlide: Number($initialSlide),
        dots: $dots,
        arrows: true,
        prevArrow: prevArrowHtml,
        nextArrow: nextArrowHtml,
        draggable: false,
        touchMove: false,
        swipeToSlide: false,
        swipe: false,
        // Issues A+B: accessible dot buttons with roving tabindex
        customPaging: function (slick, index) {
            var isActive = index === slick.currentSlide;
            return '<button type="button" role="tab"' +
                ' aria-label="Image ' + (index + 1) + ' of ' + slick.slideCount + '"' +
                ' aria-selected="' + isActive + '"' +
                ' tabindex="' + (isActive ? '0' : '-1') + '">' +
                '</button>';
        },
        responsive: [
            {
                breakpoint: $breakpoint,
                settings: 'unslick'
            }
        ]
    };
    slider.slick('unslick');
    slider.slick(settings);
    slickSlider.setupAccessibility(slider);

    slider.parent().find('.slick-sr-only').remove();

    var $dotsContainer = slider.siblings('.slick-dots');
    if (!$dotsContainer.length) {
        $dotsContainer = slider.parent().find('.slick-dots');
    }
    $dotsContainer.attr({ role: 'tablist', 'aria-label': 'Image navigation' });
    $dotsContainer.find('li').attr('role', 'presentation');

    $dotsContainer.on('keydown', 'button[role="tab"]', function (e) {
        var $tabs = $dotsContainer.find('button[role="tab"]');
        var currentIdx = $tabs.index(this);
        var nextIdx;

        if (e.which === 37 || e.which === 38) { // left / up
            e.preventDefault();
            nextIdx = currentIdx > 0 ? currentIdx - 1 : $tabs.length - 1;
        } else if (e.which === 39 || e.which === 40) { // right / down
            e.preventDefault();
            nextIdx = currentIdx < $tabs.length - 1 ? currentIdx + 1 : 0;
        } else {
            return;
        }

        $tabs.attr({ 'aria-selected': 'false', tabindex: '-1' });
        $tabs.eq(nextIdx).attr({ 'aria-selected': 'true', tabindex: '0' }).trigger('focus');
        slider.slick('slickGoTo', nextIdx);
    });

    slider.on('afterChange', function (event, slick, currentSlide) {
        var total = slick.slideCount;
        $('#modal-image-status').text('Image ' + (currentSlide + 1) + ' of ' + total);

        var $tabs = $dotsContainer.find('button[role="tab"]');
        $tabs.attr({ 'aria-selected': 'false', tabindex: '-1' });
        $tabs.eq(currentSlide).attr({ 'aria-selected': 'true', tabindex: '0' });
    });

    $(window).on('resize', debounce(function () {
        if ($(window).outerWidth() > $breakpoint) {
            return;
        }
        if (!slider.hasClass('slick-initialized')) {
            slider.slick(settings);
            slickSlider.setupAccessibility(slider);
        }
    }, 200));

    $('#modalImage .gallery-carousel').on('beforeChange', function () {
        if (window.matchMedia('(orientation: landscape)').matches) {
            zoomImgLandscape();
        } else if (window.matchMedia('(orientation: portrait)').matches) {
            zoomImgPortrait();
        }
    });
}

/**
 * Zoom functionality on PDP
 */
function loadZoom() {
    if (!isQuickView()) {
        if (isTouchDevice()) {
            window.pinchZoomObj = [];
            var $el = $('.gallery-modal .modal-mobile-img');
            if ($(window).outerWidth() < 992) {
                imagesLoaded('.gallery-modal .modal-mobile-img').off('always').on('always', function () {
                    $el.each(function () {
                        var targetElement = this;
                        var pinchZoomInstance = targetElement.gforePinchZoomInstance;

                        if (!pinchZoomInstance) {
                            if ($(targetElement).parent().hasClass('pinch-zoom-container')) {
                                return;
                            }

                            /* eslint-disable */
                            pinchZoomInstance = new pinchZoom.default(targetElement, {});
                            targetElement.gforePinchZoomInstance = pinchZoomInstance;
                        }
                        
                        window.pinchZoomObj.push(pinchZoomInstance);
                    });
                });
            }
        } else {
            $('.carousel-item.zoom', carouselPrimarySelector).each(function () {
                var $el = $('img.product-carousel-img-main', this);
                var dataZoomSrc = $el.data('zoom-src');

                if (dataZoomSrc !== undefined) {
                    $(this).zoom({
                        magnify: 1,
                        url: dataZoomSrc
                    });
                } else {
                    $(this).zoom({
                        magnify: 1
                    });
                }

                $(this).off('click keydown').on('click keydown', function (e) {
                    // Spacebar or enter key
                    if (e.type === 'keydown' && !(/^(13|32)$/.test(e.which))) {
                        return;
                    }

                    if ($(this).hasClass('zoomDesk')) {
                        $(this).removeClass('zoomDesk');
                    } else {
                        $(this).addClass('zoomDesk');
                    }
                    $(this).siblings().removeClass('zoomDesk');
                });
            });
        }
    }
}

/**
 * Resize carousels
 */
function resizeCarousels() {
    $(carouselPrimarySelector).each(function () {
        var selector = $('.carousel-inner', this);
        if (selector.length && selector.hasClass('slick-initialized')) {
            selector.slick('setPosition'); // $($(selector)[0]) hasClass('slick-initialized')
            loadZoom();
        }
    });

    $(carouselThumbnailSelector).each(function () {
        var selector = $('.slider-nav', this);
        if (selector.length && selector.hasClass('slick-initialized')) {
            selector.slick('setPosition'); // $($(selector)[0]) hasClass('slick-initialized')
        }
    });
}

/**
 * Recalculates the thumbnails height set by updateAltCarousel for the current layout
 */
function updateThumbnailsHeight() {
    $(carouselThumbnailSelector).each(function () {
        if (!this.style.height) {
            return;
        }
        var $thumbnails = $(this);
        // Reset first: the old height stretches the flex row and with it the measured primary images
        $thumbnails.css('height', '');
        $thumbnails.height($thumbnails.siblings('.primary-images').height());
    });
}

/**
 * Initiate slick slider
 */
function setSlickSlider() {
    // PDP Primary Images
    $(carouselPrimarySelector).each(function () {
        var selector = $('.carousel-inner', this);
        var selectorParent = selector.closest('.pdp-primary-images');
        if (selector.closest('.modal-float').length > 0) return;
        var selectorId = selectorParent ? selectorParent.attr('id') : '';
        var $defaultValues = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: `<a class="slide-arrow prev-arrow" href="${selectorId}" role="button" data-slide="prev"><span class="sr-only">Previous</span></a>`,
            nextArrow: `<a class="slide-arrow next-arrow" href="${selectorId}" role="button" data-slide="next"><span class="sr-only">Next</span></a>`,
            infinite: true,
            fade: false,
            speed: 400,
            accessibility: true
        };
        var $responsiveValues = {
            dots: true,
            arrows: false
        };
        slickSlider.init(selector, $defaultValues, $responsiveValues);
        selector.on('setPosition', function () {
            selector.closest('.primary-images').css('min-height', '');
        });

        selector.on('afterChange', function (event, slick, currentSlide) {
            var $dotBtns = $(this).closest(carouselPrimarySelector).find('.slick-dots button[role="tab"]');
            if (!$dotBtns.length) return;
            $dotBtns.attr({ 'aria-selected': 'false', tabindex: '-1' });
            $dotBtns.eq(currentSlide).attr({ 'aria-selected': 'true', tabindex: '0' });
            if ($(this).data('dots-key-nav')) {
                $(this).removeData('dots-key-nav');
                setTimeout(function () {
                    $dotBtns.eq(currentSlide).trigger('focus');
                }, 0);
            }
        });
    });

    // PDP Thumbnails
    $(carouselThumbnailSelector).each(function () {
        var selector = $('.slider-nav', this);
        var $defaultValues = {
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            focusOnSelect: false,
            infinite: true,
            vertical: true,
            verticalSwiping: true,
            fade: false,
            accessibility: true,
            // variableWidth: true,
            prevArrow: $('.slick-prev-thumb', this),
            nextArrow: $('.slick-next-thumb', this),
            responsive: [
                {
                    breakpoint: 1440
                },
                {
                    breakpoint: 1200
                },
                {
                    breakpoint: 992
                },
                {
                    breakpoint: 768
                }
            ]
        };
        var $responsiveValues = {
            slidesToShow: 3
        };
        selector.on('init', function () {
            $(this).find('.slick-slide.slick-current').addClass('is-active');
            loadZoom();
        });
        slickSlider.init(selector, $defaultValues, $responsiveValues);
        selector.on('setPosition', function () {
            var realHeight = selector.outerHeight();
            var $wrapper = selector.closest('.primary-images');
            var minHeight = $wrapper.length ? parseInt($wrapper.css('min-height'), 10) || 0 : 0;

            if (minHeight && realHeight >= minHeight) {
                $wrapper.css('min-height', '');
            }
        });
        $(selector).on('thumbnailcarouselreinit', function () {
            clearTimeout(resizeTimerInternal);
            resizeTimerInternal = setTimeout(resizeCarousels, 150);
        });
    });

    // After Change: Slider Nav
    $(carouselPrimarySelector + ', ' + carouselThumbnailSelector).find('.carousel-inner, .slider-nav').on('afterChange', function () {
        var $slick = $(this);
        setTimeout(function () {
            // Set all thumbnails to not selected first
            $slick.find('.thumb')
                .attr('tabindex', '-1')
                .attr('aria-pressed', 'false');
            // Only set the current (non-cloned) active slide to selected
            $slick.find('.slick-slide.slick-current:not(.slick-cloned) .thumb')
                .attr('tabindex', '0')
                .attr('aria-pressed', 'true');
        }, 300);
    });

    // After Change: Carousel Inner
    $(carouselPrimarySelector).find('.carousel-inner').on('afterChange', function (event, slick, currentSlide) {
        var thumbnails = $(this).closest('.product-detail').find('.slider-nav');
        var numberOfImages = $(this).find('.slick-slide:not(.slick-cloned)').length;
        if (thumbnails.length > 0) {
            // thumbnails.slick('slickGoTo', currentSlide);
            var currrentNavSlideElem = '.slick-slide[data-slick-index="' + currentSlide + '"]';
            var clonedCurrentNavSlideElem = '.slick-slide[data-slick-index="' + (currentSlide + numberOfImages) + '"]';
            $('.slick-slide', thumbnails).removeClass('is-active');
            $(currrentNavSlideElem, thumbnails).addClass('is-active');
            $(clonedCurrentNavSlideElem, thumbnails).addClass('is-active');
            // common.lazyLoad();
        }
    });

    // Click: Slider Nav
    $(carouselThumbnailSelector).find('.slick-slider').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');
        if (goToSingleSlide !== undefined) {
            goToSingleSlide = parseInt(goToSingleSlide, 10);
            $(carouselPrimarySelector + ' .slick-slider').slick('slickGoTo', goToSingleSlide);
        }
    });

    // Keyboard support for thumbnail buttons (Enter and Space keys)
    $(carouselThumbnailSelector).find('.slick-slider').on('keydown', '.thumb', function (event) {
        // Enter key (13) or Space key (32)
        if (event.which === 13 || event.which === 32) {
            event.preventDefault();
            var $slide = $(this).closest('.slick-slide');
            var goToSingleSlide = $slide.data('slick-index');
            if (goToSingleSlide !== undefined) {
                goToSingleSlide = parseInt(goToSingleSlide, 10);
                $(carouselPrimarySelector + ' .slick-slider').slick('slickGoTo', goToSingleSlide);
            }
        }
    });

    // Adding focus to Thumbnails ADA
    // Set all to not selected first
    $(carouselThumbnailSelector).find('.thumb')
        .attr('tabindex', '-1')
        .attr('aria-pressed', 'false');
    // Only set the current (non-cloned) active slide to selected
    $(carouselThumbnailSelector).find('.slick-current:not(.slick-cloned)').find('.thumb')
        .attr('tabindex', '0')
        .attr('aria-pressed', 'true');

    $(document).off('keydown.pdpDots').on('keydown.pdpDots', carouselPrimarySelector + ' .slick-dots button[role="tab"]', function (e) {
        if (e.which !== 37 && e.which !== 38 && e.which !== 39 && e.which !== 40) return;
        e.preventDefault();

        var $carousel = $(this).closest(carouselPrimarySelector).find('.carousel-inner.slick-initialized');
        if (!$carousel.length) return;

        var $dots = $(this).closest('.slick-dots').find('button[role="tab"]');
        var currentIdx = $dots.index(this);
        var nextIdx;

        if (e.which === 37 || e.which === 38) { // left / up
            nextIdx = currentIdx > 0 ? currentIdx - 1 : $dots.length - 1;
        } else { // right / down
            nextIdx = currentIdx < $dots.length - 1 ? currentIdx + 1 : 0;
        }

        $carousel.data('dots-key-nav', true);
        $carousel.slick('slickGoTo', nextIdx);
    });
}


$(document).on('click', '.close-add-to-basket-button', function () {
    $('.add-to-cart-modal').addClass('d-none');
});

$(document).ready(function () {
    $('.accordion .accordion-button').on('click', function (e) {
        e.preventDefault();

        const $button = $(this);
        const $collapse = $($button.attr('data-target'));
        const showDetails = $button.attr('data-show-details');
        const hideDetails = $button.attr('data-hide-details');

        if ($collapse.hasClass('show')) {
            $button.text(showDetails);
        } else {
            $button.text(hideDetails);
        }
    });
});

function syncModalCarouselHeight() {
    if (window.matchMedia('(orientation: landscape)').matches) {
        var imgHeight = $('.gallery-modal .modal-mobile-img img').first().attr('height');
        var targetHeight = imgHeight ? imgHeight + 'px' : window.innerHeight + 'px';
        $('.gallery-modal .carousel-item').css('height', targetHeight);
    } else {
        $('.gallery-modal .carousel-item').css('height', 'auto');
    }
}

function isMobileZoomViewport() {
    return $(window).outerWidth() < 992;
}

$('body').on('shown.bs.modal', '#modalImage', function () {
    $('.gallery-carousel').addClass('mobile-zoom-active');

    if (!isMobileZoomViewport()) {
        $('#modalImage').modal('hide');
        return;
    }

    var selectedelement = $('.carousel-inner').find('.slick-active').attr('data-slick-index');
    mobileOnlySlider('#modalImage .gallery-carousel', true, true, 992, selectedelement);
    syncModalCarouselHeight();

    if (window.matchMedia('(orientation: portrait)').matches) {
        zoomImgPortrait();
    } else if (window.innerHeight < window.innerWidth) {
        zoomImgLandscape();
    }

    // Issue E: move focus to close button so NVDA reads only modal content
    setTimeout(function () {
        var $closeBtn = $('#modalImageClose');
        if ($closeBtn.length) {
            $closeBtn.trigger('focus');
        }
    }, 100);

    // Issue F: announce initial image position
    var $gallery = $('#modalImage .gallery-carousel');
    if ($gallery.hasClass('slick-initialized')) {
        var slick = $gallery.slick('getSlick');
        var total = slick.slideCount;
        var current = slick.currentSlide;
        $('#modal-image-status').text('Image ' + (current + 1) + ' of ' + total);
    }

    $(window).off('orientationchange.modalImage resize.modalImage')
        .on('orientationchange.modalImage resize.modalImage', function () {
        if (!isMobileZoomViewport()) {
            $('#modalImage').modal('hide');
            return;
        }

        syncModalCarouselHeight();

        if (window.matchMedia('(orientation: landscape)').matches) {
            zoomImgLandscape();
        } else if (window.matchMedia('(orientation: portrait)').matches) {
            zoomImgPortrait();
        }
    });

    $('.product-carousel-img-main').on('pointermove', function () {
        $('.pinch-zoom-text').addClass('fade');
    });
    $('.product-carousel-img-main').on('pointerleave', function () {
        $('.pinch-zoom-text').removeClass('fade');
    });
});

$('body').on('hide.bs.modal', '#modalImage', function () {
    $(window).off('orientationchange.modalImage resize.modalImage');
    $('.gallery-modal .carousel-item').css('height', 'auto');
    $('.gallery-carousel').removeClass('mobile-zoom-active');

    var selectedelementgallery = $('.gallery-carousel.carousel-inner').find('.slick-active').attr('data-slick-index');
    $('.carousel-inner').slick('slickGoTo', selectedelementgallery);
});

$(document).on('keydown', '.js_mobile-zoom-icon', function (e) {
    if (!(/^(13|32)$/.test(e.which))) {
        return;
    }

    e.preventDefault();
    $(this).trigger('click');
});

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if (($('#quickViewModal').hasClass('show') || $('#editProductModal').hasClass('show'))
        && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').data('product-upc');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $($el).closest('.product-detail').find('.quantity-select');
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val() || 1;
}

function getAssistiveText(attrValue, msgs) {
    var parts = [];
    // if (attrValue.selected) parts.push(msgs.assistiveSelectedText);
    if (attrValue.selectable === false) parts.push(msgs.assistiveDisabledText);
    return parts.join(' ');
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $swatchButton.attr('aria-checked', 'true');
            if (attr.id !== 'color') {
                $swatchButton.closest('.product-attribute').find('.selected-attr').html($swatchButton.find('.swatch-value').data('attr-title'));
            } else {
                var colorTitle = $swatchButton.find('.swatch-value').data('attr-title');
                if (colorTitle) {
                    $swatchButton.closest('.product-attribute').find('.selected-attr')
                        .html(colorTitle.toString().toUpperCase())
                        .removeClass('d-none');
                }
            }
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $swatchButton.attr('aria-checked', 'false');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        $attrValue.toggleClass('selected', attrValue.selected);
        $attrValue.closest('.swatch-attribute').toggleClass('selected', attrValue.selected);

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }
        $attrValue.closest('.swatch-attribute').toggleClass('unorderable', !attrValue.selectable);
        $attrValue.closest('.swatch-attribute').addClass(!attrValue.selectable ? 'unorderable' : '');

        var $assist = $swatchButton.find('.selected-assistive-text');
        if ($assist.length) {
            $assist.text(getAssistiveText(attrValue, msgs));
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    attrs.forEach(function (attr) {
        processSwatchValues(attr, $productContainer, msgs);
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (response.product.readyToOrder && !response.product.isEGiftCard) {
        availabilityMessages.forEach(function (message, index) {
            availabilityValue += `
                <p class="mb-0">
                    ${index === 0 ? '<span class="sr-only text-lowercase">alert </span>' : ''}
                    ${!response.product.available
                        ? '<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i>'
                        : ''}
                    ${message}
                </p>`;
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });

    if (response.product.available) {
        $('.availabilityMsg', response.$productContainer).removeClass('out-of-stock');
    } else {
        $('.availabilityMsg', response.$productContainer).addClass('out-of-stock');
    }
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
    $productContainer.trigger('options:updated');
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images along with related information
 * @param {Object[]} zoomImageUrls - Array of xlarge product images along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, zoomImageUrls, $productContainer) {
    var isQuickView = $('.product-quickview').length > 0;
    var carousel = $productContainer.find(carouselPrimarySelector).not('.quickview-desktop-carousel');
    var mainCarousel = carousel.find('.pdp-main-carousel').first();
    var carouselTarget = mainCarousel.length ? mainCarousel : carousel;
    var carouselInnerTarget = mainCarousel.length ? carouselTarget : carouselTarget.find('.carousel-inner');
    var modalGallery = $productContainer.find('.gallery-modal .gallery-carousel').first();
    var placeholderURL = $productContainer.find('span[data-lazy-placeholder]').eq(0).attr('data-lazy-placeholder');
    var h = carousel.height();
    carousel.css('min-height', h + 'px');
    $(carouselTarget).carousel('dispose');

    if (carouselTarget.hasClass('slick-initialized')) {
        carouselTarget.slick('unslick');
    } else if (carouselInnerTarget.hasClass('slick-initialized')) {
        carouselInnerTarget.slick('unslick');
    }

    if (mainCarousel.length) {
        $(carouselTarget).empty();
    } else {
        $(carouselTarget).empty().append('<div class="carousel-inner"></div><a class="slide-arrow prev-arrow slick-arrow d-none" style=""> <span class="svgicon svg-chevron svg-chevron-dims cs-svg-icon-wrapper"> <svg> <use href="#carousel-left-arrow"></use> </svg> </span> </a><a class="slide-arrow next-arrow slick-arrow d-none" style=""> <span class="svgicon svg-chevron svg-chevron-dims cs-svg-icon-wrapper"> <svg> <use href="#carousel-left-arrow"></use> </svg> </span> </a>');
    }

    var carouselItemRole = mainCarousel.length ? 'group' : 'option';

    for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].isVideo) {
            var source = imgs[i].url ? 'data-cld-public-id="' + imgs[i].url + '" ' : '';
            var poster = imgs[i].thumbnailUrl ? 'poster="' + imgs[i].thumbnailUrl + '" ' : '';
            var position = imgs[i].position ? 'data-position="' + imgs[i].position + '" ' : '';
            var cloudName = imgs[i].cloudName ? 'data-cloud-name="' + imgs[i].cloudName + '" ' : '';
            var audio = 'data-has-audio="' + imgs[i].hasAudio + '" ';
            $('<div class="carousel-item pdp-video" role="' + carouselItemRole + '"><video id="pdp-cloudinary-video-ajax-' + imgs[i].position.toString() + '" class="cld-video-player" width="100%" ' + source + poster + position + cloudName + audio + '></video></div>').appendTo(carouselInnerTarget);
        } else if (isQuickView) {
            $('<div class="carousel-item" role="' + carouselItemRole + '"><img class="product-carousel-img-main d-block img-fluid" src="' + imgs[i].url + '" data-src="' + imgs[i].url + '" data-src-error="' + placeholderURL + '" alt="' + imgs[i].alt + '-' + parseInt(Number(imgs[i].index) + 1, 10) + '" /></div>').appendTo(carouselInnerTarget);
        } else {
            $('<div class="carousel-item zoom" role="' + carouselItemRole + '"><img class="product-carousel-img-main d-block img-fluid" src="' + imgs[i].url + '" data-src="' + imgs[i].url + '" data-zoom-src="' + zoomImageUrls[i].url + '" data-src-error="' + placeholderURL + '" alt="' + imgs[i].alt + '-' + parseInt(Number(imgs[i].index) + 1, 10) + '" /></div>').appendTo(carouselInnerTarget);
        }
    }

    if (!isQuickView && modalGallery.length) {
        if (modalGallery.hasClass('slick-initialized')) {
            modalGallery.slick('unslick');
        }

        modalGallery.empty();

        for (var j = 0; j < imgs.length; j++) {
            var modalImageURL = imgs[j].isVideo && imgs[j].thumbnailUrl ? imgs[j].thumbnailUrl : imgs[j].url;
            var modalItemClass = imgs[j].isVideo ? 'carousel-item' : 'carousel-item zoom';

            $('<div class="' + modalItemClass + '" role="option"><div class="modal-mobile-img d-flex align-items-center"><img class="product-carousel-img-main d-block img-fluid" src="' + modalImageURL + '" data-src="' + modalImageURL + '" data-src-error="' + placeholderURL + '" alt="' + imgs[j].alt + '-' + parseInt(Number(imgs[j].index) + 1, 10) + '" /></div></div>').appendTo(modalGallery);
        }

        modalGallery.find('.carousel-item').first().addClass('active');
    }

    if (!isQuickView) {
        loadZoom();
    }
    $(carouselInnerTarget).find('.carousel-item').first().addClass('active');
    if (imgs.length === 1) {
        $(carouselTarget).find('.carousel-indicators, a[class^="carousel-control-"]').detach();
    }
    if (!isQuickView) {
        setSlickSlider();
    } else {
        $('body').trigger('quickview:change');
    }
}

/**
 * Dynamically creates slick alt carousel from response containing images
 * @param {Object[]} imgs - Array of large product images, along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAltCarousel(imgs, $productContainer) {
    var thumbnails = $productContainer.find('.product-thumbnails');
    var $oldCarousel = thumbnails.find('.slider-nav');
    var $prevSlick = thumbnails.find('.slick-prev-thumb');
    var $nextSlick = thumbnails.find('.slick-next-thumb');
    var placeholderURL = $productContainer.find('span[data-lazy-placeholder]').eq(0).attr('data-lazy-placeholder');
    var mainHeight = $productContainer.find('.primary-images').height();

    if (imgs.length > 1) {
        if ($oldCarousel.hasClass('slick-initialized')) {
            $oldCarousel.slick('destroy');
        }
        // 96 x 131
        // Same visibility classes as thumbnailsCarousel.isml: thumbnails must stay hidden below md
        thumbnails.addClass('d-md-flex').removeClass('d-md-none');
        thumbnails.height(mainHeight);
        thumbnails.empty()
            .append('<div class="slider-nav order-2 p-0 mt-md-2"></div>')
            .append($prevSlick)
            .append($nextSlick);
        for (var i = 0; i < imgs.length; i++) {
            // Preload images
            var image = new Image();
            image.onload = function () {
                thumbnails.find('.slider-nav').trigger('thumbnailcarouselreinit');
            };
            image.src = imgs[i].url;

            var toAppend;
            if (imgs[i].isVideo) {
                toAppend = '<div class="thumb pdp-video-thumbnail-container"><img class="productthumbnail img-fluid" src="' + imgs[i].thumbnailUrl + '" data-src="' + imgs[i].thumbnailUrl + '" data-src-error="' + placeholderURL + '" alt="thumbnail image"/><div class="thumbnail-play-button"><span></span></div></div>';
            } else {
                toAppend = '<div class="thumb"><img class="productthumbnail img-fluid" src="' + imgs[i].url + '" data-src="' + imgs[i].url + '" data-src-error="' + placeholderURL + '" alt="' + imgs[i].alt + '"/></div>';
            }

            thumbnails.find('.slider-nav').append(toAppend);
        }
        setSlickSlider();
    } else {
        thumbnails.addClass('d-md-none').removeClass('d-md-flex');
    }
}

/**
 * Loads javascript for PDP videos
 */
function loadPDPVideos() {
    var cldPlayers = [];

    $('video.cld-video-player').each(function () {
        if ($(this).closest('.quick-modal').length > 0) {
            var quickModalID = $(this).closest('.quick-modal').attr('id');
            $(this).attr('id', $(this).attr('id') + '-' + quickModalID);
        }
        if ($(this).closest('.quickview-mobile-carousel').length > 0) $(this).attr('id', $(this).attr('id') + '-mobile');
        if ($(this).closest('.quickview-desktop-carousel').length > 0) $(this).attr('id', $(this).attr('id') + '-desktop');

        var cldPlayerID = $(this).prop('id');
        var position = $(this).data('position');
        position = position ? parseInt(position, 10) : position;

        if (cldPlayerID) {
            var cloudName = $(this).data('cloud-name');
            var player = cloudinary.videoPlayer(cldPlayerID, { // eslint-disable-line no-undef
                cloudName: cloudName,
                controls: true,
                muted: true,
                autoplayMode: position === 1 ? 'on-scroll' : 'never',
                playsinline: true,
                aspectRatio: '1:1',
                showLogo: false,
                loop: true
            });

            player.on('play', function () {
                player.videojs.autoplayOnScroll();
            });

            player.on('loadeddata', function () {
                if (player.duration() >= 20) {
                    player.loop(false);
                }
            });

            cldPlayers.push(player);
        }
    });

    $('.pdp-primary-images .slick-slider').on('afterChange', function (event, slick, currentSlide) { // eslint-disable-line no-unused-vars
        var activeCloudinaryVideoPlayerID = null;
        var $activeCarouselItem = $(this).find('.slick-active').find('.carousel-item');
        if ($activeCarouselItem && $activeCarouselItem.length && $activeCarouselItem.hasClass('pdp-video')) {
            activeCloudinaryVideoPlayerID = $activeCarouselItem.find('.cld-video-player').prop('id');
        }

        cldPlayers.forEach(player => {
            if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                player.play();
            } else {
                player.pause();
            }
        });
    });

    var isTouchClick = null;
    var $disabledSlickSlider = null;
    $('.pdp-video').on('touchstart', function (event) {
        isTouchClick = true;

        var isVolumeControl = false;
        if (event && event.target) {
            isVolumeControl = $(event.target).closest('.vjs-volume-panel').length > 0;
        }

        if (isVolumeControl) {
            var $slickSlider = $(event.target).closest('.slick-slider');
            if ($slickSlider && $slickSlider.length) {
                $disabledSlickSlider = $slickSlider;
                $slickSlider.slick('slickSetOption', 'accessibility', false);
                $slickSlider.slick('slickSetOption', 'draggable', false);
                $slickSlider.slick('slickSetOption', 'swipe', false);
                $slickSlider.slick('slickSetOption', 'touchMove', false);
            }
        }
    });
    $('.pdp-video').on('touchmove', function () {
        isTouchClick = false;
    });
    $('.pdp-video').on('touchend', function (event) {
        var isVolumeControl = false;
        if (event && event.target) {
            isVolumeControl = $(event.target).closest('.vjs-volume-panel').length > 0;
        }
        if (isTouchClick && !isVolumeControl) {
            var activeCloudinaryVideoPlayerID = $(this).find('.cld-video-player').prop('id');
            cldPlayers.forEach(player => {
                if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                    if (player.videojs.paused()) {
                        player.play();
                    } else {
                        player.pause();
                    }
                }
            });
        }

        if ($disabledSlickSlider) {
            $disabledSlickSlider.slick('slickSetOption', 'accessibility', true);
            $disabledSlickSlider.slick('slickSetOption', 'draggable', true);
            $disabledSlickSlider.slick('slickSetOption', 'swipe', true);
            $disabledSlickSlider.slick('slickSetOption', 'touchMove', true);
            $disabledSlickSlider = null;
        }
    });

    $('.pdp-video').on('mousedown', function (event) {
        var isVolumeControl = false;
        if (event && event.target) {
            isVolumeControl = $(event.target).closest('.vjs-volume-panel').length > 0;
        }

        if (isVolumeControl) {
            var $slickSlider = $(event.target).closest('.slick-slider');
            if ($slickSlider && $slickSlider.length) {
                $disabledSlickSlider = $slickSlider;
                $slickSlider.slick('slickSetOption', 'accessibility', false);
                $slickSlider.slick('slickSetOption', 'draggable', false);
                $slickSlider.slick('slickSetOption', 'swipe', false);
                $slickSlider.slick('slickSetOption', 'touchMove', false);
            }
        }
    });
    $('.pdp-video').on('mouseup', function () {
        if ($disabledSlickSlider) {
            $disabledSlickSlider.slick('slickSetOption', 'accessibility', true);
            $disabledSlickSlider.slick('slickSetOption', 'draggable', true);
            $disabledSlickSlider.slick('slickSetOption', 'swipe', true);
            $disabledSlickSlider.slick('slickSetOption', 'touchMove', true);
            $disabledSlickSlider = null;
        }
    });

    $('.pdp-video-pause-button').on('click', function () {
        var activeCloudinaryVideoPlayerID = $(this).siblings('.cld-video-player').prop('id');
        cldPlayers.forEach(player => {
            if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                player.pause();
            }
        });
    });
}

/**
 * updates explicit product set recommendations on PDP
 * @param {Object} colorCode - product selected color code string
 */
function updateExplicitProductSetRecommender(colorCode) {
    var url = $('.pdp-explicit-product-set-recommendations').attr('data-url');
    if (colorCode && url) {
        var queryString = '?pid=' + $('.product-detail').data('pid') + '&colorCode=' + colorCode;
        $.ajax({
            url: url + queryString,
            method: 'GET',
            success: function (response) {
                $('.pdp-explicit-product-set-recommendations').replaceWith(response);
            }
        });
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {boolean} reinitCarousel - Color was changes, reinit carousel.
 */
function handleVariantResponse(response, $productContainer, reinitCarousel) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }
    if (reinitCarousel && !($productContainer.hasClass('product-quickview')
        && !$productContainer.hasClass('embroidery-product-quickview'))) {
        // Update primary images
        var primaryImageUrls = response.product.images['pdp-main-desktop'];
        var zoomImageUrls = response.product.images['pdp-main-zoom'];
        var $carouselTarget = $productContainer.closest('.default-quick-view-dialog');
        if (!$carouselTarget.length) {
            $carouselTarget = $productContainer;
        }

        createCarousel(primaryImageUrls, zoomImageUrls, $carouselTarget);

        if (!$productContainer.hasClass('product-quickview')) {
            // Update alternative images carousel
            var altImagesUrl = response.product.images['pdp-thumbnail-desktop'];
            updateAltCarousel(altImagesUrl, $productContainer);
            loadPDPVideos();
        }
    }

    // common.lazyLoad();
    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : ($productContainer.closest('.modal-content').find('.prices .price').length
                ? $productContainer.closest('.modal-content').find('.prices .price')
                : $('.prices .price'));
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    if (response && response.product && response.product.priceHistoryHtml) {
        $('.price-history-container').replaceWith(response.product.priceHistoryHtml);
    } else {
        $('.price-history-container').empty();
    }

    var $quickViewPDPLink = $productContainer.find('.pdp-link');
    if ($quickViewPDPLink && $quickViewPDPLink.length > 0 && response.urls && response.urls.product) {
        $quickViewPDPLink.attr('href', response.urls.product);
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        var inQuickView = $productContainer.closest('.quick-modal').length > 0;
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            var ariaSelected = inQuickView ? ' aria-selected="' + (quantity.selected ? 'true' : 'false') + '"' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + ariaSelected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Updates the Fit DOM elements post Ajax call
 * @param {string} productFitHtml - The HTML representing the product fit
 */
function updateProductFit(productFitHtml) {
    var $productFit = $('.js-product-fit');
    if (productFitHtml) {
        $productFit
            .removeClass('d-none')
            .find('.js-fit-info')
            .empty()
            .html(productFitHtml);
    } else {
        $productFit.addClass('d-none');
    }
}

/**
 * hides or shows the new color text based on the currently selected color
 * @param {jQuery} $colorButton - the selected color button
 * @param {jQuery} $newTextDiv - the new color text div
 */
function toggleNewColorText($colorButton, $newTextDiv) {
    var hideTextDiv = !$colorButton.hasClass('is-new') || $colorButton.hasClass('unorderable');
    $newTextDiv.toggleClass('d-none', hideTextDiv);
}

/**
 * hides or shows the final sale text based on the currently selected color
 * @param {jQuery} $colorButton - the selected color button
 * @param {jQuery} $newTextDiv - the final sale text div
 */
function toggleFinalSaleText($colorButton, $newTextDiv) {
    var hideTextDiv = !$colorButton.hasClass('is-final-sale') || $colorButton.hasClass('unorderable');
    $newTextDiv.toggleClass('d-none', hideTextDiv);
}

/**
 * updates the product gallery asset content on the PDP
 * @param {Object} product - product object from the response
 * @param {jQuery} $productContainer - DOM container for current product
 */
function updateProductGalleryAsset(product, $productContainer) {
    var $productGalleryAssetContainer = $('.product-gallery-asset-container', $productContainer);
    if (product && $productGalleryAssetContainer && $productGalleryAssetContainer.length) {
        if (product.productGalleryAsset && product.productGalleryAsset.html && product.productGalleryAsset.id) {
            if ($productGalleryAssetContainer.data('asset-id') !== product.productGalleryAsset.id) {
                $productGalleryAssetContainer.html(product.productGalleryAsset.html);
                $productGalleryAssetContainer.data('asset-id', product.productGalleryAsset.id);
            }
        } else {
            $productGalleryAssetContainer.empty();
            $productGalleryAssetContainer.data('asset-id', null);
        }
    }
}

function onQuickViewImagesLoaded(element, callback) {
    let images = element ? element.querySelectorAll('img') : [];
    let imagesToLoad = images.length;
    let imagesLoaded = 0;

    if (imagesToLoad === 0) {
        callback(); // No images, trigger immediately
        return;
    }

    function imageLoaded() {
        imagesLoaded++;
        if (imagesLoaded === imagesToLoad) {
            callback();
        }
    }

    images.forEach(img => {
        if (img.complete) {
        // If the image is already loaded (e.g., from cache),
        // call imageLoaded() immediately.
            imageLoaded();
        } else {
            img.addEventListener('load', imageLoaded);
            img.addEventListener('error', imageLoaded); // Consider error case
        }
    });

    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
        setTimeout(callback, 300);
    }
}

function handleQuickViewImagesLoaded() {
    var $carouselToRemove = $('#quickViewModal, #editProductModal').find('.modal-float .parent-image-carousel.js-remove');
    var $newCarousel = $('#quickViewModal, #editProductModal').find('.modal-float .parent-image-carousel.js-new');
    $carouselToRemove.remove();
    $newCarousel.removeClass('invisible').removeClass('js-new');
    $('#quickViewModal, #editProductModal').find('.modal-float').removeClass('d-none');
    $('#quickViewModal, #editProductModal').each(function () {
        // Re-measured on every size change, not once (see quickViewScrollMore)
        scrollMore.watch($(this));
    });
    $.spinner().stop();
}

function setCustomEGiftCardDesign($productContainer) {
    var egcAttrContainer = $productContainer.find('.e-gift-card-attribute');
    if (egcAttrContainer.length) {
        if (egcAttrContainer.find('.egift-swatch-value.color-value.selected').length) {
            $productContainer.find('.js-egc-selected-design').val(egcAttrContainer.find('.egift-swatch-value.color-value.selected').data('attr-value'));
        }
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {element} $clickedColor - the color selected by user
 * @param {string} selectionType - the type of selection made by the user
 */
function attributeSelect(selectedValueUrl, $productContainer, $clickedColor, selectionType) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });
        var reinitCarousel = $clickedColor !== undefined;
        var reinitQuickviewModalFloatImages = false;

        if (selectionType !== 'quantitySelect') {
            selectedValueUrl = utils.appendParamToURL(selectedValueUrl, 'quantity', '1');
            selectedValueUrl = selectedValueUrl.replace(/([?&])quantity=[^&]*/i, '$1quantity=1');
        }

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                var isQuickView = $('.quick-modal.show').length > 0;
                reinitQuickviewModalFloatImages = reinitCarousel && data.product.imageCarouselHtml.length && $productContainer.hasClass('product-quickview') && !$productContainer.hasClass('embroidery-product-quickview');

                handleVariantResponse(data, $productContainer, reinitCarousel);
                updateOptions(data.product.optionsHtml, $productContainer);

                updateQuantities(data.product.quantities.slice(0, data.product.availability.ats), $productContainer);

                setCustomEGiftCardDesign($productContainer);

                var pdpCustomMsg = data.product.pdpCustomMsgCopyid;
                $('.pdp-custom-msg', $productContainer).empty();

                if (pdpCustomMsg) {
                    $('.pdp-custom-msg', $productContainer).empty().html(pdpCustomMsg);
                }

                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                if ($clickedColor) {
                    updateProductFit(data.product.productFit);
                    var selectorString = $clickedColor.parents('.color-price-group').length ? '.color-price-group' : '.product-attribute';
                    $('.selected-attr.colorPriceGroup', $productContainer).html('');
                    $('.new-color-text', $productContainer).addClass('d-none');
                    $('.final-sale-text', $productContainer).addClass('d-none');
                    if ($clickedColor.find('.color-value').hasClass('selected')) {
                        $clickedColor.closest(selectorString).find('.selected-attr').html($clickedColor.find('.color-value').data('attr-title').toString().toUpperCase()).removeClass('d-none');
                        toggleNewColorText($clickedColor, $clickedColor.closest(selectorString).find('.new-color-text'));
                        toggleFinalSaleText($clickedColor, $clickedColor.closest(selectorString).find('.final-sale-text'));
                    } else {
                        $clickedColor.closest(selectorString).find('.selected-attr').html('').addClass('d-none');
                    }

                    updateProductGalleryAsset(data.product, $productContainer);
                }
                $productContainer.find('.quantity-select').removeAttr('disabled');
                if (reinitQuickviewModalFloatImages) {
                    var $modalDialog = $productContainer.closest('.modal-dialog');
                    var $quickviewMobileCarousel = $modalDialog.find('.quickview-mobile-carousel .parent-image-carousel');
                    if ($quickviewMobileCarousel.length) {
                        $quickviewMobileCarousel.replaceWith(data.product.imageCarouselHtml);
                        $('body').trigger('quickview:change');
                    }

                    var $parentImageCarousel = $modalDialog.find('.modal-float .parent-image-carousel');
                    $parentImageCarousel.addClass('js-remove');

                    var $newImageCarousel = $(data.product.imageCarouselHtml);
                    $newImageCarousel.addClass('js-new').addClass('invisible');
                    $newImageCarousel.insertAfter($parentImageCarousel);
                    onQuickViewImagesLoaded($modalDialog.find('.modal-float').get(0), handleQuickViewImagesLoaded);
                } else if (reinitCarousel && data.product.imageCarouselHtml.length && !$productContainer.hasClass('product-quickview')) {
                    var $parentPdpImageCarousel = $productContainer.find('.parent-image-carousel');
                    $parentPdpImageCarousel.replaceWith(data.product.imageCarouselHtml);

                    if (!isQuickView) {
                        setSlickSlider();
                        loadPDPVideos();
                        loadZoom();
                    }
                }

                $('.quantity-wrapper .arrow-wrapper .arrow').removeClass('blue-caret-up');

                if (data && data.product) {
                    if (data.product.promotionsHtml) {
                        $('.promotions').removeClass('d-none').html(data.product.promotionsHtml);
                    } else {
                        $('.promotions').addClass('d-none').empty();
                    }
                }

                if (!reinitQuickviewModalFloatImages) $.spinner().stop();
                if (data.gtmDataLayer) {
                    window.dataLayer = window.dataLayer || [];
                    for (var ind = 0; ind < data.gtmDataLayer.length; ind++) {
                        window.dataLayer.push(data.gtmDataLayer[ind]);
                    }
                }

                if (data && data.canonicalUrl) {
                    var canonicalLink = document.querySelector('link[rel="canonical"]');
                    if (canonicalLink) {
                        canonicalLink.href = data.canonicalUrl;
                    }

                    var ogUrl = document.querySelector('meta[property="og:url"]');
                    if (ogUrl) {
                        ogUrl.setAttribute('content', data.canonicalUrl);
                    }
                }

                var newOgImage = null;
                if (data && data.product && data.product.images) {
                    var pdpMain = data.product.images['pdp-main-desktop'];
                    if (pdpMain && pdpMain.length && pdpMain[0].url) {
                        newOgImage = pdpMain[0].url;
                    } else {
                        var thumb = data.product.images['pdp-thumbnail-desktop'];
                        if (thumb && thumb.length && thumb[0].url) newOgImage = thumb[0].url;
                    }
                }

                if (!newOgImage && data && data.product && data.product.primaryImageUrl) {
                    newOgImage = data.product.primaryImageUrl;
                }

                if (newOgImage) {
                    var ogImgMeta = document.querySelector("meta[property='og:image']");
                    var ogImgSecure = document.querySelector("meta[property='og:image:secure_url']");

                    if (ogImgMeta) ogImgMeta.setAttribute('content', newOgImage);
                    if (ogImgSecure) ogImgSecure.setAttribute('content', newOgImage);

                    if (data.canonicalUrl && !isQuickView) {
                        history.replaceState(null, '', data.canonicalUrl);
                    }
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {string} pid - product id
 */
function handlePostCartAdd(response, pid) {
    if (!response.error) {
        $('.minicart').data('pid', pid);
        $('.minicart').trigger('count:update', response.cart);

        $('body').trigger('updateCartPage', response);

        if (response.promoProgressBarPreAddProduct && response.promoProgressBarPreAddProduct.html) {
            if ($('.pre-add-product-promo-progress-bar-container').length > 0) {
                $('.pre-add-product-promo-progress-bar-container').empty();
            } else {
                $('body').append('<div class="pre-add-product-promo-progress-bar-container d-none"></div>');
            }
            $('.pre-add-product-promo-progress-bar-container').append(response.promoProgressBarPreAddProduct.html);
        }

        $('.minicart').trigger('click', { isAddToCart: true });
    } else {
        $.spinner().stop();
    }
    $('body').trigger('product:afterAddToCart');
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (!response.error) {
            $('.minicart').focusin();
            var minicartTimer = window.setTimeout(function () {
                $('.minicart').focusout();
            }, 5000);
            $('.minicart-flyout').off('mouseenter').on('mouseenter', function () {
                window.clearTimeout(minicartTimer);
            });
        }
        var messageType = response.error ? 'alert-danger' : 'alert-success';
        if ($('.add-to-cart-messages').length >= 1) {
            $('.add-to-cart-messages').remove();
        }

        var isQuickView = $('.quick-modal.show').length > 0;

        if ($('.add-to-cart-messages').length === 0) {
            if (isQuickView) {
                $('.quick-modal .modal-content').append(
                    '<div class="add-to-cart-messages"></div>'
                );
            } else {
                $('body').append(
                    '<div class="add-to-cart-messages"></div>'
                );
            }
        }

        if ($('.ats-error-alert').length >= 1) {
            $('.ats-error-alert').remove();
        }

        if (response.error && response.message) {
            if (response.atsError) {
                $('.availability-msg').append(
                    '<div class="alert ' + messageType + ' ats-error-alert text-center mt-2" role="alert">'
                    + response.message
                    + '</div>'
                );
            } else {
                var value = isQuickView ? 0 : $('.header-navigation').innerHeight() + $('.header-banner').innerHeight() + 'px';
                $('.add-to-cart-messages').css('top', value);
                $(window).scroll(function () {
                    if (($('.add-to-basket-alert').length !== 0)) {
                        var updatedValue = $('.header-navigation').innerHeight() + $('.header-banner').innerHeight() + 'px';
                        $('.add-to-cart-messages').css('top', updatedValue);
                    }
                });
                $('.add-to-cart-messages').append(
                    '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
                    + response.message
                    + '</div>'
                );
            }
        }

        if (!response.enabledATC) {
            $('.product-detail .quantity-select').val('1');
            $('.product-detail .quantity-select').attr('disabled', true);
        }

        $('.add-to-basket-alert').fadeOut(3000, function () {
            $(this).remove();
            if (isQuickView) {
                $('.quick-modal.show .modal-close-container').addClass('show');
            }
        });
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').data('product-upc'),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
    .find('.product-option')
    .map(function () {
        return {
            optionId: $(this).data('option-id'),
            selectedValueId: $productContainer.find('.embroidery').data('value-id') === 'yes' ? $(this).data('value-id') : $('.option-btn', this).data('value-id')
        };
    }).toArray();

    return JSON.stringify(options);
}

/**
 * Get the url for the selected attribute
 * @param {string} selector - Options Selector
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} url - Current url
 * @return {string} url to be used for request
 */
function resetOptions(selector, $productContainer, url) {
    /* eslint-disable no-param-reassign */
    $productContainer.find(selector).each(function () {
        url = url.replace($(this).data('value-id'), $('.option-btn', this).data('value-id'));
    });
    return url;
}

/**
 * Get the url for the selected attribute
 * @param {jquery} option - Clicked attribute
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} url of the option
 */
function getUrl(option, $productContainer) {
    var url = option.attr('data-url');
    if (url && option.closest('.option-btn:not(.embroidery_yes)').length > 0 && url.indexOf('yes') > -1) {
        url = url.replace('yes', 'no');
    } else if (option.closest('.embroidery_no').length > 0) {
        if (option.closest('#editProductModal').length > 0) {
            $productContainer.find('.embroidery_no').data('url', $productContainer.find('.cancel-url').data('url'));
            url = $productContainer.find('.embroidery_no').data('url');
            var productNewURL = $('.option-btn').data('url');
            var productNewId = productNewURL.substring(productNewURL.search('pid='), productNewURL.search('&quantity'));
            productNewId = productNewId.replace('pid=', '');
            var productOldId = $('.product-options').data('product-upc') || $('.product-options').data('product-id').toString();
            url = url.split(productOldId).join(productNewId);
        } else {
            url = resetOptions('.product-option', $productContainer, url);
        }
    } else if (option.closest('.embroideryLogo').length > 0) {
        url = resetOptions('.product-option:not(.embroideryLogo)', $productContainer, url);
    }
    return url;
}

/**
 * Show options messages
 * @param {jquery} option - Clicked option
 * @param {jQuery} $productContainer - DOM container for a given product
 * @return {boolean} retrun boolean to check if there's options missed or not
 */
function validateOptions(option, $productContainer) {
    var result = false;
    if (option.hasClass('embroidery_yes')) {
        $productContainer.find('.option-error').addClass('d-none');
        var $options = $productContainer.find('.product-option');
        $options.each(function () {
            if ($(this).find('.selected').length === 0) {
                $(this).find('.option-error').removeClass('d-none');
                $productContainer.find('.embroidery').find('.option-error').removeClass('d-none');
                result = true;
            }
        });
    }
    return result;
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

function colorAttributeMouseover(attribute) {
    if ($(attribute).attr('disabled')) {
        return;
    }
    var selectorString = $(attribute).parents('.color-price-group').length ? '.color-price-group' : '.product-attribute';
    $(attribute).closest(selectorString).find('.selected-attr').html($(attribute).find('.color-value').data('attr-title').toString()
                .toUpperCase())
                .removeClass('d-none');

    // show/hide new color label on mouseover
    $(attribute).closest(selectorString).find('.new-color-text').toggleClass('d-none', !$(attribute).hasClass('is-new'));
    $(attribute).closest(selectorString).find('.final-sale-text').toggleClass('d-none', !$(attribute).hasClass('is-final-sale'));
}

function colorAttributeMouseout(attribute) {
    if ($(attribute).attr('disabled')) {
        return;
    }
    var $root = $(attribute).closest('.product-detail');
    var selectorString = $(attribute).parents('.color-price-group').length ? '.color-price-group' : '.product-attribute';
    if ((selectorString === '.product-attribute' && $root.find('.color-attribute .color-value').hasClass('selected'))
                || $(attribute).closest(selectorString).find('.color-attribute .color-value.selected').length) {
        $(attribute).closest(selectorString).find('.selected-attr').html($root.find('.color-attribute .color-value.selected').data('attr-title').toString().toUpperCase())
                    .removeClass('d-none');
    } else {
        $(attribute).closest(selectorString).find('.selected-attr').html('')
                    .addClass('d-none');
    }

    // show/hide new color label on mouseout
    var newColorSelectedInColorGroup = $(attribute).closest(selectorString).find('.color-attribute.selected.is-new').length;
    $(attribute).closest(selectorString).find('.new-color-text').toggleClass('d-none', !newColorSelectedInColorGroup);
    var finalSaleSelectedInColorGroup = $(attribute).closest(selectorString).find('.color-attribute.selected.is-final-sale').length;
    $(attribute).closest(selectorString).find('.final-sale-text').toggleClass('d-none', !finalSaleSelectedInColorGroup);
}

function announceBisnMessages($form) {
    var $messages = $form.find('.bisn-messages');
    if ($messages.length > 0 && $messages.text().trim()) {
        var messageText = $messages.text().trim();
        var $announcer = $('#bisn-sr-announcer');
        if ($announcer.length === 0) {
            $announcer = $('<div>', {
                id: 'bisn-sr-announcer',
                class: 'sr-only',
                role: 'status',
                'aria-live': 'polite',
                'aria-atomic': 'true'
            }).appendTo('body');
        }
        $announcer.empty();
        setTimeout(function () {
            $announcer.text(messageText);
        }, 100);
    }
}

function loadBisn($container) {
    var $bisnContainer = $('.bisncontainer', $container);
    var bisnButton = $('button.bis-notify-me', $container);
    var addToCart = $('button.add-to-cart', $container);
    var $bisnSubscriptionForm = $('.bisnSubscriptionForm', $container);
    if ($bisnContainer.find('.biscontainer-hidden').length > 0) {
        var bisColorValue = $bisnContainer.find('.biscontainer-hidden').val();
        $('.attribute', $container).find('.color-attribute').each(function () {
            var currColorValue = $(this).attr('data-attr-value');
            if (bisColorValue === currColorValue && $(this).hasClass('selected')) {
                $bisnContainer.removeClass('d-none');
                $bisnSubscriptionForm.removeClass('d-none');
                addToCart.addClass('d-none');
                bisnButton.text(bisnButton.data('bisnbutton-msg'));
                bisnButton.attr('disabled', false);
                // Trigger announcement of BISN messages for screen readers
                announceBisnMessages($bisnSubscriptionForm);
            }
        });
    } else {
        $bisnContainer.addClass('d-none');
        $bisnSubscriptionForm.addClass('d-none');
        addToCart.removeClass('d-none');
    }
}

module.exports = {
    initResizeHandlers: function () {
        if (isResizeInitialized) {
            return;
        }
        isResizeInitialized = true;
        $(window).on('resize orientationchange', function () {
            clearTimeout(resizeTimerInternal);
            resizeTimerInternal = setTimeout(resizeCarousels, 150);
            clearTimeout(thumbnailsHeightTimer);
            thumbnailsHeightTimer = setTimeout(updateThumbnailsHeight, 150);
        });
    },
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
        loadBisn: loadBisn,
        toggleNewColorText: toggleNewColorText,
        toggleFinalSaleText: toggleFinalSaleText,
        announceBisnMessages: announceBisnMessages
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled') || $(this).find('.swatch-value').hasClass('selected')) {
                return;
            }
            $(this).closest('.product-attribute').find('.invalidAttr').addClass('d-none');

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            var url = $(this).attr('data-url');
            if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                url = utils.appendParamToURL(url, 'isSectionOpened', 'true');
            }

            var colorCode = $(this).find('span').first().data('attr-value');
            updateExplicitProductSetRecommender(colorCode);

            attributeSelect(url, $productContainer, $(this));
            loadZoom();
        });
    },

    setColorAttribute: function () {
        var $colorSwatches = $('[data-attr="color"] button');
        $colorSwatches.each(function () {
            if ($(this).find('.swatch-item').hasClass('selected')) {
                var selectorString = $(this).parents('.color-price-group').length ? '.color-price-group' : '.product-attribute';
                $(this).closest(selectorString).find('.selected-attr').html($(this).find('.color-value').data('attr-title').toUpperCase())
                .removeClass('d-none');
                toggleNewColorText($(this), $(this).closest(selectorString).find('.new-color-text'));
                toggleFinalSaleText($(this), $(this).closest(selectorString).find('.final-sale-text'));
            }
        });

        var $colorSwatch = $('.color-attribute');
        $($colorSwatch).on('mouseover', function (e) {
            e.preventDefault();
            colorAttributeMouseover(this);
        });

        $($colorSwatch).on('mouseout', function (e) {
            e.preventDefault();
            colorAttributeMouseout(this);
        });

        $(document).on('mouseover', '.quick-modal .color-attribute', function (e) {
            e.preventDefault();
            colorAttributeMouseover(this);
        });

        $(document).on('mouseout', '.quick-modal .color-attribute', function (e) {
            e.preventDefault();
            colorAttributeMouseout(this);
        });
    },
    swatchesAttribute: function () {
        $(document).on('click', '.attribute button:not(.color-attribute, .size-chart-pdp__link), .option-btn', function (e) {
            e.preventDefault();
            if ($(this).attr('disabled') || $(this).find('.swatch-value').hasClass('selected')) {
                return;
            }

            $(this).closest('.product-attribute').find('.invalidAttr').addClass('d-none');
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            var url = getUrl($(this), $productContainer);
            if (validateOptions($(this), $productContainer)) {
                return;
            }
            if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                url = utils.appendParamToURL(url, 'isSectionOpened', 'true');
            }

            attributeSelect(url, $productContainer);
        });
    },
    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            var url = e.currentTarget.value;
            if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                url = utils.appendParamToURL(url, 'isSectionOpened', 'true');
            }
            attributeSelect(url, $productContainer, undefined, 'quantitySelect');
        });
    },

    availability: function () {
        $(document).on('click', '.quantity-select', function (e) {
            e.preventDefault();
            $('.quantity-wrapper .arrow-wrapper .arrow').addClass('blue-caret-up');
        });
        $(document).on('blur', '.quantity-select', function (e) {
            e.preventDefault();
            $('.quantity-wrapper .arrow-wrapper .arrow').removeClass('blue-caret-up');
        });
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();
            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                var url = $(e.currentTarget).find('option:selected').data('url');
                if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                    url = utils.appendParamToURL(url, 'isSectionOpened', 'true');
                }
                attributeSelect(url, $productContainer, undefined, 'quantitySelect');
            }
        });
    },
    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var $customForm = null;

            $(e.target).removeClass('no-focus');

            if ($(e.target).hasClass('undo-btn')) {
                return; // Exit the handler
            }

            /* commented this code per PM-1512 : Allow customers to use special characters in gift message field */
            // var $giftMessage = $('#giftMessage');
            // if ($giftMessage.length > 0 && $giftMessage.val().trim() !== '') {
            //     // eslint-disable-next-line no-useless-escape
            //     var giftMessageRegex = new RegExp(/^[\w *;\/"%()#?.'!$,\-\n]*$/);
            //     if (!giftMessageRegex.test($giftMessage.val().trim())) {
            //         $('.invalid-feedback-gift-message').removeClass('d-none');
            //         return;
            //     }
            // }
            $('.invalid-feedback-gift-message').addClass('d-none');

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }
            $('.invalidAttr').addClass('d-none');
            var readyToOrder = true;
            $productContainer.find('.product-attribute').each(function () {
                if ($(this).find('.selected').length === 0) {
                    if ($(this).hasClass('e-gift-card-attribute')) {
                        var $customAmount = $productContainer.find('[id*="egiftcard-custom-amount"]');
                        if ($customAmount.length && $customAmount.val() && $customAmount.val().trim() !== '') {
                            return;
                        }
                    }
                    $(this).find('.invalidAttr').removeClass('d-none');
                    readyToOrder = false;
                }
            });
            if (!readyToOrder) {
                $(this).closest('.cart-and-ipay').find('.invalidAttr').removeClass('d-none');
                return;
            }

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').data('product-upc'),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            // handle the addition of custom "attributes" on the PDP
            var customFormName = $(this).data('custom-form-name');
            var customData = {};
            if (customFormName && $('form[name="' + customFormName + '"]').length) {
                // get form object
                $customForm = $('form[name="' + $(this).data('custom-form-name') + '"]');

                customData = $customForm.serializeArray().reduce(function (obj, item) {
                    obj[item.name] = item.value;
                    return obj;
                }, {});
            }

            addToCartUrl = getAddToCartUrl();
            var masterProductIDValue = $productContainer.find('[id="masterProductIDValue"]').val();
            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this)),
                customData: JSON.stringify(customData),
                masterProductIDValue: masterProductIDValue,
                isCartPage: $('.cart-page').length > 0
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        var gtmProductDetails = data.gtmProductDetails;
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'productAdd',
                            quantity: form.quantity,
                            master_upc: gtmProductDetails.masterProductId,
                            style_number: gtmProductDetails.manufacturerSKU,
                            upc: gtmProductDetails.variantID || '',
                            color_value: gtmProductDetails.color_value || '',
                            color: gtmProductDetails.color || '',
                            size: gtmProductDetails.size || '',
                            dmpk: gtmProductDetails.length || gtmProductDetails.inseam || gtmProductDetails.hand || gtmProductDetails.width || '',
                            collegiate: gtmProductDetails.isEmbroidered
                        });

                        $('body').trigger('product:afterAddToCartGtm', {
                            gtmProductDetails: gtmProductDetails,
                            quantity: form.quantity
                        });

                        handlePostCartAdd(data, pid);
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                    complete: function () {
                        // client wants focus-style removed from ATB button after it's clicked
                        setTimeout(function () {
                            $(e.target).not('no-focus').addClass('no-focus');
                        }, 500);
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                    + '<div class="selected-pid row" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="col-sm-11 col-9 bonus-product-name" >'
                    + $choiceOfBonusProduct.find('.product-name').html()
                    + '</div>'
                    + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                    + '</div>'
                    ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        if (data.totalQty > 0) {
                            $('.minicart-quantity').removeClass('no-quantity-items');
                            $('.minicart-flyout').removeClass('empty-cart');
                        } else {
                            $('.minicart-quantity').addClass('no-quantity-items');
                            $('.minicart-flyout').addClass('empty-cart');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    bisnFeature: function () {
        loadBisn($('.container.product-detail'));
        $('body').on('click', '.backInStockNotification .bisnButton', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $bisContainer = $this.closest('.bisncontainer');
            var pid = $this.closest('.quick-modal').length > 0 ? $('.quick-modal .product-detail').data('pid') : $('.product-detail').data('pid');
            var emailInput = $this.closest('.email-submit');
            var email = emailInput.find('.bisnemail').val();
            var addToEmailList = $bisContainer.find('#addemailList').is(':checked');
            var subscriptionSuccessMessage = $this.data('subscription-success-message');
            var subscriptionErrorMessage = $this.data('subscription-error-message');

            var emailAddressError = {
                emptyEmail: $this.data('empty-email'),
                emailFormat: $this.data('email-format'),
                invalidEmail: $this.data('invalid-email'),
                invalidEmail1: $this.data('invalid-email1')
            };

            var errorMsg = emailAddressError.invalidEmail + ' \'' + email + '\' ' + emailAddressError.invalidEmail1;
            var url = $this.data('url');
            var accountID = $this.data('account-id');

            var reg = /^[A-Za-z0-9Ã„Ã–ÃœÃ¤Ã¶Ã¼ÃŸ_$*+/=!?{}~^.-]+@[\w.-]+\.[\w]{2,6}$/; // eslint-disable-line

            if (email === '' || email === null || email.indexOf('@') === -1 || reg.test(email) === false) {
                $bisContainer.find('#bisnemailnstatus').empty().addClass('d-none');
                emailInput.find('.bisnemail').addClass('is-invalid');
                emailInput.find('.bisnemail').closest('.form-group').addClass('is-invalid');
            }

            var $invalidFeedback = emailInput.find('.invalid-feedback');
            var alertPrefix = $invalidFeedback.hasClass('sr-alert') ? '<span class="sr-only">alert&nbsp;</span>' : '';
            var $errorMsg = $invalidFeedback.find('.errormsg');
            var $target = $errorMsg.length ? $errorMsg : $invalidFeedback;

            // Ensure ARIA live region attributes are set for screen readers
            if (!$target.attr('aria-live')) {
                $target.attr({
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                });
            }

            // Update error message with a slight delay to ensure screen readers announce it
            var updateErrorMessage = function (message) {
                setTimeout(function () {
                    $target.html(message);
                }, 100);
            };

            if (email === '' || email === null) {
                updateErrorMessage(alertPrefix + emailAddressError.emptyEmail);
            } else if (email.indexOf('@') === -1) {
                updateErrorMessage(alertPrefix + errorMsg);
            } else if (reg.test(email) === false) {
                updateErrorMessage(alertPrefix + emailAddressError.emailFormat);
            } else {
                emailInput.find('.bisnemail').removeClass('is-invalid');
                emailInput.find('.bisnemail').closest('.form-group').removeClass('is-invalid');

                var klaviyorMsg = '';
                var requestData = {
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            channels: ['EMAIL'],
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: email
                                    }
                                }
                            }
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: 'catalog-variant',
                                    id: '$sfcc:::' + window.klaviyo_catalog_id + ':::' + pid
                                }
                            }
                        }
                    }
                };

                if (url && accountID) {
                    url += '/?company_id=' + accountID;
                }

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: JSON.stringify(requestData),
                    beforeSend: function (request) {
                        request.setRequestHeader('accept', 'application/vnd.api+json');
                        request.setRequestHeader('content-type', 'application/vnd.api+json');
                        request.setRequestHeader('revision', '2025-04-15');
                    },
                    success: function (data) {
                        var responseJSON = data && 'responseText' in data ? JSON.parse(data.responseText) : {};
                        $bisContainer.find('.success-message-box').removeClass('d-none');
                        $bisContainer.find('.bisnemail').removeClass('error');
                        $bisContainer.find('#bisnemailnstatus').removeClass('d-none');
                        $bisContainer.find('.success').text(data.successMsg);
                        if ('message' in responseJSON) {
                            klaviyorMsg += klaviyorMsg.length > 0 ? '\n' + responseJSON.message : responseJSON.message;
                        } else {
                            klaviyorMsg += klaviyorMsg.length > 0 ? '\n' + subscriptionSuccessMessage : subscriptionSuccessMessage;
                        }
                        $bisContainer.find('#bisnemailnstatus').text(klaviyorMsg);
                        $bisContainer.find('.bisnSubscriptionForm').addClass('d-none');
                    },
                    error: function (data) {
                        var responseJSON = data && 'responseText' in data ? JSON.parse(data.responseText) : {};
                        $bisContainer.find('.bisnSubscriptionForm').addClass('d-none');
                        $bisContainer.find('.success-message-box').removeClass('d-none');
                        if (responseJSON && responseJSON.errors && responseJSON.errors.length > 0) {
                            var responseError = responseJSON.errors[0];
                            if (responseError && responseError.detail) {
                                klaviyorMsg += klaviyorMsg.length > 0 ? '\n' + responseError.detail : responseError.detail;
                                $bisContainer.find('#bisnemailnstatus').removeClass('d-none').text(klaviyorMsg);
                            }
                        }
                    }
                });

                if (addToEmailList) {
                    var subscriptionUrl = $this.data('subscription-url');
                    var masterListID = $this.data('master-list-id');
                    if (subscriptionUrl && accountID) {
                        subscriptionUrl += '/?company_id=' + accountID;
                    }

                    var subscriptionRequestData = {
                        data: {
                            type: 'subscription',
                            attributes: {
                                custom_source: 'Form submission',
                                profile: {
                                    data: {
                                        type: 'profile',
                                        attributes: { email: email }
                                    }
                                }
                            },
                            relationships: { list: { data: { type: 'list', id: masterListID } } }
                        }
                    };

                    $.ajax({
                        type: 'POST',
                        url: subscriptionUrl,
                        data: JSON.stringify(subscriptionRequestData),
                        beforeSend: function (request) {
                            request.setRequestHeader('revision', '2024-02-15');
                            request.setRequestHeader('content-type', 'application/json');
                        },
                        success: function (data) {
                            var responseJSON = data && 'responseText' in data ? JSON.parse(data.responseText) : {};
                            if ('message' in responseJSON) {
                                $bisContainer.find('#bisnemailnstatus').text(responseJSON.message);
                            }
                        },
                        error: function (data) {
                            var responseJSON = data && 'responseText' in data ? JSON.parse(data.responseText) : {};
                            if ('message' in responseJSON) {
                                $bisContainer.find('#bisnemailnstatus').removeClass('d-none').text(responseJSON.message);
                            }
                            klaviyorMsg += klaviyorMsg.length > 0 ? '\n' + subscriptionErrorMessage : subscriptionErrorMessage;
                            $bisContainer.find('#bisnemailnstatus').removeClass('d-none').text(klaviyorMsg);
                        }
                    });
                }
            }
        });
    },
    comingSoonFeature: function () {
        $('body').on('click', '.comingSoonNotification .comingSoonButton', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $comingSoonContainer = $this.closest('.comingSoonNotification');
            var pid = $('.product-detail').data('pid');
            var emailInput = $this.closest('.email-submit');
            var email = emailInput.find('.comingSoonEmail').val();
            var addToEmailList = $comingSoonContainer.find('#comingsoon-addemailList').is(':checked');
            var subscriptionSuccessMessage = $this.data('subscription-success-message');
            var comingSoonErrorMessage = $this.data('comingsoon-error-message');
            var subscriptionErrorMessage = $this.data('subscription-error-message');
            var comingSoonEventName = $this.data('comingsoon-event-name');
            var klaviyoError = false;
            var klaviyoErrorMsg = '';

            var emailAddressError = {
                emptyEmail: $this.data('empty-email'),
                emailFormat: $this.data('email-format'),
                invalidEmail: $this.data('invalid-email'),
                invalidEmail1: $this.data('invalid-email1')
            };
            var errorMsg = emailAddressError.invalidEmail + ' \'' + email + '\' ' + emailAddressError.invalidEmail1;

            var reg = /^[A-Za-z0-9Ã„Ã–ÃœÃ¤Ã¶Ã¼ÃŸ_$*+/=!?{}~^.-]+@[\w.-]+\.[\w]{2,6}$/; // eslint-disable-line
            if (email === '' || email === null || email.indexOf('@') === -1 || reg.test(email) === false) {
                $comingSoonContainer.find('#comingsoon-emailnstatus').empty().addClass('d-none');
                emailInput.find('.comingSoonEmail').addClass('is-invalid');
                emailInput.find('.comingSoonEmail').closest('.form-group').addClass('is-invalid');
                emailInput.find('.invalid-feedback').show();
            }

            var $invalidFeedback = emailInput.find('.invalid-feedback');
            var alertPrefix = $invalidFeedback.hasClass('sr-alert') ? '<span class="sr-only">alert&nbsp;</span>' : '';
            var $errorMsg = $invalidFeedback.find('.errormsg');
            var $target = $errorMsg.length ? $errorMsg : $invalidFeedback;

            // Ensure ARIA live region attributes are set for screen readers
            if (!$target.attr('aria-live')) {
                $target.attr({
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                });
            }

            if (email === '' || email === null) {
                $target.html(alertPrefix + emailAddressError.emptyEmail);
            } else if (email.indexOf('@') === -1) {
                $target.html(alertPrefix + errorMsg);
            } else if (reg.test(email) === false) {
                $target.html(alertPrefix + emailAddressError.emailFormat);
            } else {
                emailInput.find('.comingSoonEmail').removeClass('is-invalid');
                emailInput.find('.comingSoonEmail').closest('.form-group').removeClass('is-invalid');
                emailInput.find('.invalid-feedback').hide();

                if (klaviyo) { // eslint-disable-line no-undef
                    klaviyo.identify({ // eslint-disable-line no-undef
                        email: email
                    }).then(setTimeout(function () {
                        klaviyo.track(comingSoonEventName, { ProductId: pid }); // eslint-disable-line no-undef
                    }, 1000));
                } else {
                    klaviyoError = true;
                    klaviyoErrorMsg += comingSoonErrorMessage + ' ';
                }

                if (addToEmailList) {
                    var url = $this.data('subscription-url');
                    var accountID = $this.data('account-id');
                    var masterListID = $this.data('master-list-id');

                    if (url && accountID) {
                        url += '/?company_id=' + accountID;
                    }

                    var requestData = {
                        data: {
                            type: 'subscription',
                            attributes: {
                                custom_source: 'Form submission',
                                profile: {
                                    data: {
                                        type: 'profile',
                                        attributes: { email: email }
                                    }
                                }
                            },
                            relationships: { list: { data: { type: 'list', id: masterListID } } }
                        }
                    };

                    $.ajax({
                        type: 'POST',
                        url: url,
                        data: JSON.stringify(requestData),
                        beforeSend: function (request) {
                            request.setRequestHeader('revision', '2024-02-15');
                            request.setRequestHeader('content-type', 'application/json');
                        },
                        success: function (data) {
                            var responseJSON = data && 'responseText' in data ? JSON.parse(data.responseText) : {};
                            if ('message' in responseJSON) {
                                $comingSoonContainer.find('#comingsoon-emailnstatus').text(responseJSON.message);
                            }
                        },
                        error: function (data) {
                            var responseJSON = data && 'responseText' in data ? JSON.parse(data.responseText) : {};
                            if ('message' in responseJSON) {
                                $comingSoonContainer.find('#comingsoon-emailnstatus').removeClass('d-none').text(responseJSON.message);
                            }
                            klaviyoError = true;
                            klaviyoErrorMsg += subscriptionErrorMessage;
                        }
                    });
                }

                if (klaviyoError) {
                    $comingSoonContainer.find('.comingSoonSubscriptionForm').addClass('d-none');
                    $comingSoonContainer.find('.success-message-box').removeClass('d-none');
                    $comingSoonContainer.find('#comingsoon-emailnstatus').removeClass('d-none').text(klaviyoErrorMsg);
                } else {
                    $comingSoonContainer.find('.success-message-box').removeClass('d-none');
                    $comingSoonContainer.find('.comingSoonEmail').removeClass('error');
                    $comingSoonContainer.find('#comingsoon-emailnstatus').removeClass('d-none');
                    $comingSoonContainer.find('#comingsoon-emailnstatus').text(subscriptionSuccessMessage);
                    $comingSoonContainer.find('.comingSoonSubscriptionForm').addClass('d-none');
                }
            }
        });
    },
    updateCount: function () {
        $(document).on('count:update', '.minicart', function (evt, response) {
            if (!breakpoints.isDesktopView() && !response.error) {
                var $addToBagPrice = $('.add-to-bag-price');
                $('.add-to-cart-modal').removeClass('d-none');
                $addToBagPrice.find('.numitems').text(response.numItems < 100 ? response.numItems : 99);
                $addToBagPrice.find('.subtotal').text(response.totals.subTotal);
                if (response.numItems > 1) {
                    let itemsText = $addToBagPrice.find('.label-items').data('moreitems');
                    $addToBagPrice.find('.label-items').text(itemsText);
                }
            }
        });
    },
    loadZoom: loadZoom,
    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    setSlickSlider: setSlickSlider,
    initGiftMessageCharacterCounter: giftMessage.initCharacterCounter,
    handlePDPVideo: function () {
        $(document).ready(function () {
            loadPDPVideos();
        });
    }
};
